export let onCopyFailedNotificationText = "DsqsHd";
export let onMoveFailedNotificationText = "FPmVm";
export default {onCopyFailedNotificationText,onMoveFailedNotificationText};